import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@shadcn-in-nx/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@shadcn-in-nx/ui/select";
import { Search, X, Zap, LayoutGrid } from "lucide-react";

export { VerificationFilter } from "./VerificationFilter";

const CATEGORIES = [
    { value: "all", labelKey: "blueprints.allCategories" },
    { value: "AUTOMATION", labelKey: "blueprints.automations", icon: Zap },
    { value: "APP_V2", labelKey: "blueprints.apps", icon: LayoutGrid },
];

export function CategoryTabs({ category, onChange }) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-2 border-b pb-0">
            {CATEGORIES.map((cat) => {
                const isActive = category === cat.value;
                const Icon = cat.icon;
                return (
                    <button
                        key={cat.value}
                        onClick={() => onChange(cat.value)}
                        className={`flex items-center gap-1.5 px-4 py-2 text-sm font-medium border-b-2 transition-colors -mb-px ${
                            isActive
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300"
                        }`}
                    >
                        {Icon ? <Icon className="h-4 w-4" /> : null}
                        {t(cat.labelKey)}
                    </button>
                );
            })}
        </div>
    );
}

export function SearchAndSort({
    searchTerm,
    onSearchChange,
    onClearSearch,
    sortValue,
    onSortChange,
}) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
            <div className="relative flex-1 max-w-sm">
                <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
                <Input
                    placeholder={t("blueprints.searchPlaceholder")}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="pl-10"
                />
                {searchTerm ? (
                    <button
                        onClick={onClearSearch}
                        className="absolute right-3 top-3 text-muted-foreground hover:text-foreground"
                    >
                        <X className="h-4 w-4" />
                    </button>
                ) : null}
            </div>
            <div className="flex items-center gap-3">
                <Select value={sortValue} onValueChange={onSortChange}>
                    <SelectTrigger className="w-[160px]">
                        <SelectValue placeholder={t("blueprints.sortBy")} />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="createdAt-desc">{t("blueprints.newest")}</SelectItem>
                        <SelectItem value="createdAt-asc">{t("blueprints.oldest")}</SelectItem>
                        <SelectItem value="name-asc">{t("blueprints.nameAZ")}</SelectItem>
                        <SelectItem value="name-desc">{t("blueprints.nameZA")}</SelectItem>
                        <SelectItem value="downloadCount-desc">{t("blueprints.mostPopular")}</SelectItem>
                    </SelectContent>
                </Select>
            </div>
        </div>
    );
}

